module.exports = __webpack_public_path__ + "static/media/robot.e8f69fc5.png";